// extracted by mini-css-extract-plugin
export default {"GamesList":"LcGamesList_GamesList__uh5B-"};